import { render, staticRenderFns } from "./lainnya.vue?vue&type=template&id=3b5ce1ce&"
import script from "./lainnya.vue?vue&type=script&lang=js&"
export * from "./lainnya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QFile,QIcon,QCardActions,QImg,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QFile,QIcon,QCardActions,QImg}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
